export class Message {
	public id: string;
	public length: number;
	public phoneNumberCount: number;

	constructor() {
		this.id = "";
		this.length = 0;
		this.phoneNumberCount = 0;
	}
}

export default class BatchMessageDraftModel {
	public preSubmissionConfigurationId: string;
	public messages: Message[];
	public partitionKey: string;

	constructor() {
		this.preSubmissionConfigurationId = "";
		this.messages = [];
		this.partitionKey = "";
	}
}
